import dayjs from 'dayjs'

export const GetTodayDayjs = (): any => {
    return dayjs()
  };
  